// extracted by mini-css-extract-plugin
module.exports = {"passwordStyles":"room__styles__passwordStyles___-uNWdb","showStyles":"room__styles__showStyles___18TQYd"};